module.exports = __webpack_public_path__ + "img/AISocialAgents-Dark.6f5cdf2e.svg";